import React from 'react';
import { TextAreaTypeV2, TextAreaV2 } from '@wajeez-web/components/ui';
import { FieldValues, UseControllerProps } from 'react-hook-form';

import { TextAreaFormType } from '../Types';
import { FormInputController } from '../FormInputController';

export interface FormTextAreaV2Props<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields>,
    TextAreaTypeV2 {
  fieldMeta: TextAreaFormType;
  validationErrorMessages?: Partial<{
    required: string;
    pattern: string;
    minLength: string;
    maxLength: string;
  }>;
  readOnly?: boolean;
}

export const FormTextAreaV2 = <TFormFields extends FieldValues>({
  name,
  fieldMeta,
  validationErrorMessages,
  readOnly,
  ...props
}: FormTextAreaV2Props<TFormFields>) => {
  return (
    <FormInputController
      name={name}
      fieldMeta={fieldMeta}
      renderInput={({ ...controllerProps }) => (
        <TextAreaV2
          label={fieldMeta.label}
          placeholder={fieldMeta.placeHolder}
          required={fieldMeta.required}
          {...controllerProps}
          {...props}
        />
      )}
      {...props}
    />
  );
};
